module.exports = __webpack_public_path__ + "assets/media/footer-image.23a572f3.svg";